import React, { createContext, useContext, useEffect, useState } from 'react';

// Create the context
const SidebarContext = createContext();

// Create a provider component
export const SidebarProvider = ({ children }) => {
  // const [sidebarWidth, setSidebarWidth] = useState("280px"); // Default width (in pixels)
  const [sidebarWidth, setSidebarWidth] = useState(() =>
    window.innerWidth <= 768 ? "0px" : "280px" // Set to 0px on mobile by default
  );
  const [openedList, setOpenedList] = useState(sessionStorage.getItem("activeSidebarList") || "dashboard");

  useEffect(()=>{
    setOpenedList(sessionStorage.getItem("activeSidebarList"));
  },[]);

  const handleOpenedList = (list) => {
    sessionStorage.setItem("activeSidebarList", list);
    setOpenedList(list);
  }

  // Toggle sidebar width or set to a specific value
  const toggleSidebarWidth = () => {
    setSidebarWidth((prevWidth) => (prevWidth === "280px" ? "0px" : "280px"));
  };

  return (
    <SidebarContext.Provider value={{ sidebarWidth, setSidebarWidth, toggleSidebarWidth, openedList, handleOpenedList }}>
      {children}
    </SidebarContext.Provider>
  );
};

// Custom hook to use the SidebarContext
export const useSidebar = () => useContext(SidebarContext);
